import { render } from "./LateralMenu.vue?vue&type=template&id=29db4d14&scoped=true"
import script from "./LateralMenu.vue?vue&type=script&lang=js"
export * from "./LateralMenu.vue?vue&type=script&lang=js"

import "./LateralMenu.vue?vue&type=style&index=0&id=29db4d14&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29db4d14"]])

export default __exports__